<template>
  <gj-popover
      v-model="visible"
      placement="top"
      :width="width"
      load
      trigger="manual"
      :title="popTitle">
    <template slot="reference">
      <el-row
          type="flex"
          align="middle"
          :class="{'edit-content': fixedIcon}"
          :style="{'justify-content': align === 'right' ? 'flex-end' : ''}">
        <div :class="{'text-ellipsis-2':ellipsis===2,'text-ellipsis-1':ellipsis===1}"><slot>{{value | defaultShow}}</slot></div>
        <div class="edit-icon" :class="{'gj-cell-display-switch': tableCellEdit}" @click="memoEdit()" v-if="isEdit">
          <i class="el-icon-edit pen-icon"></i>
        </div>
      </el-row>
    </template>
    <template v-if="type === 'textarea'">
      <gj-textarea
          v-model="dataValue"
          :styles="{height: height}">
      </gj-textarea>
    </template>
    <template v-else-if="type === 'date'">
      <gj-date-picker
          v-model="dataValue"
          v-bind="editConfig"
          width="100%"
      ></gj-date-picker>
    </template>
    <div style="text-align: right; margin-top: 14px;">
      <gj-button :size="'mini'" @click="close()">取消</gj-button>
      <gj-button
          :size="'mini'"
          type="primary"
          :disabled="confirmDisabled"
          @click="confirm()"
          :loading="loading"
      >确定</gj-button>
    </div>
  </gj-popover>
</template>

<script>
  import GjTextarea from "./gj-textarea";
  import GjPopover from "../popover/gj-popover";
  import {isMeaningless} from "../../utils/common";
  export default {
    name: "gj-edit-input",
    components: {GjPopover, GjTextarea},
    props: {
      ellipsis:{
        type:Number,
        default: 2
      },
      value: null,
      onConfirm: {
        type: Function
      },
      isEdit: {
        type: Boolean,
        default: true
      },
      item: {
        type: Object
      },
      type: {
        type: String,
        default: 'textarea',
        validator: function (value) {
          return ['textarea', 'date'].indexOf(value) !== -1
        }
      },
      editConfig: {
        default: () => {}
      },
      popTitle: {
        type: String
      },
      tableCellEdit: {
        type: Boolean,
        default: false
      },
      fixedIcon: {
        type: Boolean,
        default: false
      },
      align: {
        type: String,
        default: 'left'
      },
      validator: {
        type: Function,
        default: () => true
      },
      height: {
        type: String,
        default: '100px'
      },
      width: {
        type: String,
        default: '240'
      }
    },
    watch: {
      value: {
        handler(value) {
          this.dataValue = value;
        },
        immediate: true
      }
    },
    data() {
      return {
        dataValue: null,
        visible: false,
        loading: false
      }
    },
    created() {
      this.dataValue = this.value;
    },
    computed: {
      confirmDisabled() {
        return !this.validator(this.dataValue);
      }
    },
    methods: {
      memoEdit() {
        this.visible = true;
      },
      close() {
        this.visible = false;
        this.dataValue = this.value;
      },
      confirm() {
        this.loading = true;
        this.onConfirm(this.dataValue, this.item, () => {
          this.visible = false;
          this.loading = false;
        }, () => {
          this.loading = false;
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  .edit-content {
    padding-right: 15px;
    position: relative;
    .edit-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }
  }
  .pen-icon {
    cursor: pointer;
    margin-left: 5px;
    font-size: 13px;
  }
</style>
